// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Paper,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   Typography,
//   Box,
//   MenuItem,
//   Checkbox,
//   FormControlLabel,
// } from "@mui/material";

// const DisplayBibleSurveys = () => {
//   const API_URL = process.env.REACT_APP_API_URL;

//   const [surveys, setSurveys] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const [openDetails, setOpenDetails] = useState(false);
//   const [openEdit, setOpenEdit] = useState(false);
//   const [openDelete, setOpenDelete] = useState(false);

//   const [selectedSurvey, setSelectedSurvey] = useState(null);
//   const [formData, setFormData] = useState({});

//   const [testament, setTestament] = useState("old");
//   const [language, setLanguage] = useState("amharic");

//   // ================= FETCH =================
//   useEffect(() => {
//     fetchSurveys();
//   }, []);

//   const fetchSurveys = async () => {
//     try {
//       const res = await fetch(
//         // `${API_URL}/bible-surveys/books?testament=${testament}&language=${language}`,
//         `${API_URL}/bible-survey/books`,
//       );

//       const result = await res.json();
//       console.log(result);

//       if (result.success) {
//         setSurveys(result.data || []);
//         console.log(result.data);
//       }
//     } catch (err) {
//       console.error("Fetch error:", err);
//     }
//   };

//   // ================= FILTER =================
//   const handleSearch = () => {
//     fetchSurveys();
//     setPage(0);
//   };

//   // ================= PAGINATION =================
//   const handlePageChange = (_, newPage) => {
//     setPage(newPage);
//   };

//   const handleRowsPerPageChange = (e) => {
//     setRowsPerPage(parseInt(e.target.value, 10));
//     setPage(0);
//   };

//   // ================= DIALOGS =================
//   const handleOpenDetails = async (survey) => {
//     try {
//       const res = await fetch(
//         `${API_URL}/bible-surveys/surveys/${survey.bookId}`,
//       );

//       const result = await res.json();

//       if (result.success) {
//         setSelectedSurvey(result.data);
//         console.log(result.data);
//         setOpenDetails(true);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleOpenEdit = async (survey) => {
//     try {
//       const res = await fetch(
//         `${API_URL}/bible-surveys/${survey.bookId}?language=${survey.language}`,
//       );

//       const result = await res.json();

//       if (result.success) {
//         setSelectedSurvey(result.data);

//         setFormData({
//           language: result.data.language,
//           provider: result.data.provider,
//           model: result.data.model,
//           contributor: result.data.contributor,
//           verified: result.data.verified,
//           content: JSON.stringify(result.data.content, null, 2),
//         });

//         setOpenEdit(true);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleOpenDelete = (survey) => {
//     setSelectedSurvey(survey);
//     setOpenDelete(true);
//   };

//   const handleClose = () => {
//     setOpenDetails(false);
//     setOpenEdit(false);
//     setOpenDelete(false);
//     setSelectedSurvey(null);
//     setFormData({});
//   };

//   // ================= INPUT =================
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   // ================= UPDATE =================
//   const handleUpdate = async () => {
//     try {
//       const contentObj = JSON.parse(formData.content);

//       const res = await fetch(
//         `${API_URL}/bible-surveys/${selectedSurvey.bookId}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             language: formData.language,
//             content: contentObj,
//             provider: formData.provider,
//             model: formData.model,
//             contributor: formData.contributor,
//             verified: formData.verified,
//           }),
//         },
//       );

//       if (res.ok) {
//         fetchSurveys();
//       }
//     } catch (err) {
//       console.error("Update error:", err);
//     } finally {
//       handleClose();
//     }
//   };

//   // ================= DELETE =================
//   const handleDelete = async () => {
//     try {
//       await fetch(
//         `${API_URL}/bible-surveys/${selectedSurvey.bookId}?language=${selectedSurvey.language}`,
//         {
//           method: "DELETE",
//         },
//       );

//       setSurveys((prev) =>
//         prev.filter(
//           (s) =>
//             !(
//               s.bookId === selectedSurvey.bookId &&
//               s.language === selectedSurvey.language
//             ),
//         ),
//       );
//     } catch (err) {
//       console.error("Delete error:", err);
//     } finally {
//       handleClose();
//     }
//   };

//   return (
//     <>
//       {/* ================= FILTERS ================= */}
//       <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//         <TextField
//           select
//           label="Testament"
//           value={testament}
//           onChange={(e) => setTestament(e.target.value)}
//           sx={{ minWidth: 180 }}
//         >
//           <MenuItem value="old">Old Testament</MenuItem>
//           <MenuItem value="new">New Testament</MenuItem>
//         </TextField>

//         <TextField
//           label="Language"
//           value={language}
//           onChange={(e) => setLanguage(e.target.value)}
//           sx={{ minWidth: 180 }}
//         />

//         <Button variant="contained" onClick={handleSearch}>
//           Search
//         </Button>

//         <Button variant="outlined" onClick={fetchSurveys}>
//           Refresh
//         </Button>
//       </Box>

//       {/* ================= TABLE ================= */}
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Book</TableCell>
//               <TableCell>Book Am</TableCell>
//               <TableCell>Testament</TableCell>
//               <TableCell>Language</TableCell>
//               <TableCell>Version</TableCell>
//               <TableCell>Verified</TableCell>
//               <TableCell>User Edited</TableCell>
//               <TableCell>Updated</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {surveys
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((survey) => (
//                 <TableRow key={survey.id}>
//                   <TableCell>{survey.name}</TableCell>
//                   <TableCell>{survey.nameAm}</TableCell>
//                   <TableCell>{survey.testament}</TableCell>
//                   <TableCell>{survey.language}</TableCell>
//                   <TableCell>{survey.chapters}</TableCell>
//                   <TableCell>{survey.verified ? "Yes" : "No"}</TableCell>
//                   <TableCell>{survey.isUserEdited ? "Yes" : "No"}</TableCell>
//                   <TableCell>{survey.updatedAt}</TableCell>

//                   <TableCell
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: 1,
//                     }}
//                   >
//                     <Button
//                       size="small"
//                       variant="contained"
//                       onClick={() => handleOpenEdit(survey)}
//                     >
//                       Edit
//                     </Button>

//                     <Button
//                       size="small"
//                       color="error"
//                       variant="contained"
//                       onClick={() => handleOpenDelete(survey)}
//                     >
//                       Delete
//                     </Button>

//                     <Button
//                       size="small"
//                       variant="outlined"
//                       onClick={() => handleOpenDetails(survey)}
//                     >
//                       View
//                     </Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>

//         <TablePagination
//           component="div"
//           count={surveys.length}
//           page={page}
//           rowsPerPage={rowsPerPage}
//           onPageChange={handlePageChange}
//           onRowsPerPageChange={handleRowsPerPageChange}
//         />
//       </TableContainer>

//       {/* ================= DETAILS ================= */}
//       <Dialog open={openDetails} onClose={handleClose} maxWidth="md" fullWidth>
//         <DialogTitle>Bible Survey Details</DialogTitle>

//         <DialogContent>
//           <Typography>
//             <b>Book:</b> {selectedSurvey?.bookName}
//           </Typography>

//           <Typography>
//             <b>Book Am:</b> {selectedSurvey?.bookNameAm}
//           </Typography>

//           <Typography>
//             <b>Language:</b> {selectedSurvey?.language}
//           </Typography>

//           <Typography>
//             <b>Provider:</b> {selectedSurvey?.provider}
//           </Typography>

//           <Typography>
//             <b>Model:</b> {selectedSurvey?.model}
//           </Typography>

//           <Typography>
//             <b>Contributor:</b> {selectedSurvey?.contributor}
//           </Typography>

//           <Typography>
//             <b>Version:</b> {selectedSurvey?.version}
//           </Typography>

//           <Typography>
//             <b>Hits:</b> {selectedSurvey?.hits}
//           </Typography>

//           <TextField
//             label="Content JSON"
//             multiline
//             rows={20}
//             fullWidth
//             margin="dense"
//             value={JSON.stringify(selectedSurvey?.content, null, 2)}
//             InputProps={{
//               readOnly: true,
//             }}
//           />
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleClose}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* ================= EDIT ================= */}
//       <Dialog open={openEdit} onClose={handleClose} maxWidth="md" fullWidth>
//         <DialogTitle>Edit Bible Survey</DialogTitle>

//         <DialogContent>
//           <TextField
//             label="Provider"
//             name="provider"
//             value={formData.provider || ""}
//             onChange={handleChange}
//             fullWidth
//             margin="dense"
//           />

//           <TextField
//             label="Model"
//             name="model"
//             value={formData.model || ""}
//             onChange={handleChange}
//             fullWidth
//             margin="dense"
//           />

//           <TextField
//             label="Contributor"
//             name="contributor"
//             value={formData.contributor || ""}
//             onChange={handleChange}
//             fullWidth
//             margin="dense"
//           />

//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.verified || false}
//                 onChange={handleChange}
//                 name="verified"
//               />
//             }
//             label="Verified"
//           />

//           <TextField
//             label="Content JSON"
//             name="content"
//             value={formData.content || ""}
//             onChange={handleChange}
//             multiline
//             rows={20}
//             fullWidth
//             margin="dense"
//           />
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleClose}>Cancel</Button>

//           <Button onClick={handleUpdate}>Save</Button>
//         </DialogActions>
//       </Dialog>

//       {/* ================= DELETE ================= */}
//       <Dialog open={openDelete} onClose={handleClose}>
//         <DialogTitle>Delete Bible Survey</DialogTitle>

//         <DialogContent>
//           Delete survey for <b>{selectedSurvey?.bookName}</b> ?
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleClose}>Cancel</Button>

//           <Button color="error" onClick={handleDelete}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default DisplayBibleSurveys;

import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Box,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

const DisplayBibleSurveys = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [surveys, setSurveys] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openDetails, setOpenDetails] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [formData, setFormData] = useState({});

  const [testament, setTestament] = useState("old");
  const [language, setLanguage] = useState("amharic");

  // ================= FETCH SURVEYS =================
  useEffect(() => {
    fetchSurveys();
  }, [testament, language]);

  const fetchSurveys = async () => {
    try {
      const res = await fetch(`${API_URL}/bible-survey/books`);

      const result = await res.json();

      if (result.success) {
        setSurveys(result.data || []);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  // ================= PAGINATION =================
  const handlePageChange = (_, newPage) => setPage(newPage);

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  // ================= VIEW DETAILS =================
  const handleOpenDetails = async (survey) => {
    try {
      const res = await fetch(`${API_URL}/bible-survey/surveys/${survey.id}`);

      const result = await res.json();
      console.log(result);

      if (result.success) {
        setSelectedSurvey(result.data);
        setOpenDetails(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ================= EDIT =================
  const handleOpenEdit = async (survey) => {
    try {
      const res = await fetch(`${API_URL}/bible-survey/surveys/${survey.id}`);

      const result = await res.json();

      if (result.success) {
        setSelectedSurvey(result.data);

        setFormData({
          language: result.data.language,
          provider: result.data.provider,
          model: result.data.model,
          contributor: result.data.contributor,
          verified: result.data.verified,
          content: JSON.stringify(result.data.content, null, 2),
        });

        setOpenEdit(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleOpenDelete = (survey) => {
    setSelectedSurvey(survey);
    setOpenDelete(true);
  };

  const handleClose = () => {
    setOpenDetails(false);
    setOpenEdit(false);
    setOpenDelete(false);
    setSelectedSurvey(null);
    setFormData({});
  };

  // ================= INPUT =================
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ================= UPDATE =================
  const handleUpdate = async () => {
    try {
      const contentObj = JSON.parse(formData.content);

      const res = await fetch(
        `${API_URL}/bible-survey/surveys/${selectedSurvey.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            language: formData.language,
            content: contentObj,
            provider: formData.provider,
            model: formData.model,
            contributor: formData.contributor,
            verified: formData.verified,
          }),
        },
      );

      if (res.ok) {
        fetchSurveys();
      }
    } catch (err) {
      console.error("Update error:", err);
    } finally {
      handleClose();
    }
  };

  // ================= DELETE =================
  const handleDelete = async () => {
    try {
      await fetch(`${API_URL}/bible-survey/surveys/${selectedSurvey.id}`, {
        method: "DELETE",
      });

      setSurveys((prev) =>
        prev.filter(
          (s) =>
            !(
              s.bookId === selectedSurvey.bookId &&
              s.language === selectedSurvey.language
            ),
        ),
      );
    } catch (err) {
      console.error("Delete error:", err);
    } finally {
      handleClose();
    }
  };

  return (
    <>
      {/* ================= FILTERS ================= */}
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <TextField
          select
          label="Testament"
          value={testament}
          onChange={(e) => setTestament(e.target.value)}
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="old">Old Testament</MenuItem>
          <MenuItem value="new">New Testament</MenuItem>
        </TextField>

        <TextField
          label="Language"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          sx={{ minWidth: 180 }}
        />

        <Button variant="contained" onClick={fetchSurveys}>
          Refresh
        </Button>
      </Box>

      {/* ================= TABLE ================= */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Book</TableCell>
              <TableCell>Book Am</TableCell>
              <TableCell>Testament</TableCell>
              <TableCell>Language</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Verified</TableCell>
              <TableCell>User Edited</TableCell>
              <TableCell>Updated</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {surveys
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((survey) => (
                <TableRow key={survey.id}>
                  <TableCell>{survey.name}</TableCell>
                  <TableCell>{survey.nameAm}</TableCell>
                  <TableCell>{survey.testament}</TableCell>
                  <TableCell>{survey.language}</TableCell>
                  <TableCell>{survey.chapters}</TableCell>
                  <TableCell>{survey.verified ? "Yes" : "No"}</TableCell>
                  <TableCell>{survey.isUserEdited ? "Yes" : "No"}</TableCell>
                  <TableCell>{survey.updatedAt}</TableCell>

                  <TableCell
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleOpenEdit(survey)}
                    >
                      Edit
                    </Button>

                    <Button
                      color="error"
                      variant="contained"
                      size="small"
                      onClick={() => handleOpenDelete(survey)}
                    >
                      Delete
                    </Button>

                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleOpenDetails(survey)}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={surveys.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </TableContainer>

      {/* ================= DETAILS ================= */}
      <Dialog open={openDetails} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Bible Survey Details</DialogTitle>
        <DialogContent>
          <Typography>
            <b>Book:</b> {selectedSurvey?.bookName}
          </Typography>
          <Typography>
            <b>Language:</b> {selectedSurvey?.language}
          </Typography>
          <Typography>
            <b>Provider:</b> {selectedSurvey?.provider}
          </Typography>
          <Typography>
            <b>Model:</b> {selectedSurvey?.model}
          </Typography>
          <Typography>
            <b>Version:</b> {selectedSurvey?.version}
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={20}
            value={JSON.stringify(selectedSurvey?.content, null, 2)}
            InputProps={{ readOnly: true }}
            margin="dense"
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* ================= EDIT ================= */}
      <Dialog open={openEdit} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Edit Bible Survey</DialogTitle>

        <DialogContent>
          <TextField
            name="provider"
            label="Provider"
            value={formData.provider || ""}
            onChange={handleChange}
            fullWidth
            margin="dense"
          />

          <TextField
            name="model"
            label="Model"
            value={formData.model || ""}
            onChange={handleChange}
            fullWidth
            margin="dense"
          />

          <TextField
            name="contributor"
            label="Contributor"
            value={formData.contributor || ""}
            onChange={handleChange}
            fullWidth
            margin="dense"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={formData.verified || false}
                onChange={handleChange}
                name="verified"
              />
            }
            label="Verified"
          />

          <TextField
            name="content"
            label="Content JSON"
            value={formData.content || ""}
            onChange={handleChange}
            fullWidth
            multiline
            rows={20}
            margin="dense"
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleUpdate} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================= DELETE ================= */}
      <Dialog open={openDelete} onClose={handleClose}>
        <DialogTitle>Delete Survey</DialogTitle>
        <DialogContent>
          Delete <b>{selectedSurvey?.bookName}</b>?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button color="error" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisplayBibleSurveys;
